import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, change, reduxForm } from 'redux-form';
import { createSelector } from 'reselect';
import { InlineEditorActions } from '../../actions/inlineEditor';

// import _ from 'lodash';

const InlineFormValueSelector = (state, props) => {
  // console.log('inlineForm', props.value, props.form, props.uid);
  // console.log('===================================', props.value);
  return Immutable.Iterable.isIterable(props.value)
    ? props.value.toJS()
    : props.value;
  // const formName = props.form;
  // if (!formName) return null;
  // const selector = formValueSelector(formName);
  // console.log('inlineFFFFF', selector(state, 'field'), formName, props);
  // return selector(state, 'field');
};

const isEditingSelector = (state, props) =>
  state.inlineEditors.getIn(['editors', props.form], null);

const inlineSelector = createSelector(
  [isEditingSelector, InlineFormValueSelector],
  (editing, inlineForm) => ({
    editing,
    initialValues: {
      field: inlineForm,
    },
  }),
);

@connect(inlineSelector)
@reduxForm({
  // form: '', // dynamic form name is coming in as a prop called "form"
  destroyOnUnmount: true,
})
export default class InlineEditorForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    value: PropTypes.any,
    form: PropTypes.string,
    component: PropTypes.any,
    editing: PropTypes.bool,
    onSave: PropTypes.func,
    inlineTypeOptions: PropTypes.object,
    propertyKey: PropTypes.string,
    metaKey: PropTypes.string,
    handleSubmit: PropTypes.func,
    reset: PropTypes.func,
    showHelpText: PropTypes.bool,
    customHelpText: PropTypes.string,
    disableKeyDown: PropTypes.bool,
    meta: PropTypes.object,
    currentElementId: PropTypes.string,
    customMeta: PropTypes.bool,
    fieldIndex: PropTypes.number,
    providesToConsumesFrom: PropTypes.object,
  };

  toggleInlineEdit = (setValue = true) => {
    const { dispatch, form, editing, value } = this.props;
    dispatch(InlineEditorActions.setInlineEditState(form, !editing));
    if (setValue) {
      dispatch(change(form, 'field', value));
    }
  };

  submit = (values, dispatch) => {
    const {
      component,
      customMeta,
      inlineTypeOptions,
      propertyKey,
      metaKey,
      onSave,
    } = this.props;

    const editValue = values.field;

    if (propertyKey && onSave) {
      if (metaKey) {
        // console.log('metakey submit');
        const metaProps = customMeta
          ? { [metaKey]: { _value: editValue } }
          : { [metaKey]: editValue }; // for metadata properties
        return onSave.call(null, propertyKey, metaProps); // for ElementType related changes
      }
      // console.log('prop submit');
      const props = { [propertyKey]: editValue };
      return onSave.call(null, props, inlineTypeOptions, component);
    }

    return onSave.call(null, editValue); // This is for general use
  };

  handleCancel = () => {
    // console.log('cancel');
    const { dispatch, form } = this.props;
    dispatch(InlineEditorActions.unsetInlineEditState(form));
    // dispatch(InlineEditorActions.setInlineEditState(form, false));
  };

  handleKeyDown = e => {
    if (e.key === 'Escape') {
      return this.handleCancel();
    }

    if (e.key === 'Enter' && !e.shiftKey) {
      return this.props.handleSubmit(this.submit);
    }

    return undefined;
  };

  render = () => {
    const {
      component,
      value,
      form,
      onSave,
      editing,
      handleSubmit,
      showHelpText,
      customHelpText,
      disableKeyDown,
      inlineTypeOptions,
      currentElementId,
      fieldIndex,
      validation,
      providesToConsumesFrom,
      buttonClassOverride,
    } = this.props;

    const buttons = editing
      ? (
        <div
          className="btn-group d-flex justify-content-end"
          style={buttonClassOverride || {}}
        >
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleSubmit(this.submit)}
          >
            <i className="fa fa-check" />
          </button>
          <button
            className="btn btn-outline-secondary"
            type="button"
            onClick={this.handleCancel}
          >
            <i className="fa fa-times" />
          </button>
        </div>
      ) : null;

    // const valueOutput = (value && value !== null) ? value.toString() : 'Click to edit';

    const displayHelpText =
      showHelpText && editing ? (
        <small className="text-muted">{/* Type: String. */}</small>
      ) : null;
    const propHelpText =
      customHelpText && editing ? (
        <small className="text-muted prop-help-text">{customHelpText}</small>
      ) : null;

    const keyDown = !disableKeyDown ? this.handleKeyDown : null;
    const typeOptions = inlineTypeOptions || null;
    // console.log('inline type opts', inlineTypeOptions);
    const displayField = (
      <div className="inline-edit-input">
        <form onSubmit={handleSubmit(this.submit)}>
          <div className="input-group2">
            <Field
              name="field"
              component={component.editor}
              val={value}
              uid={form}
              onSave={onSave}
              validate={validation}
              toggleEditor={this.toggleInlineEdit}
              onKeyDown={keyDown}
              editing={editing}
              inlineTypeOptions={typeOptions}
              currentElementId={currentElementId}
              fieldIndex={fieldIndex}
              providesToConsumesFrom={providesToConsumesFrom}
            />
            {buttons}
          </div>
        </form>
        {displayHelpText} {propHelpText}
      </div>
    );

    return displayField;
  };
}



// WEBPACK FOOTER //
// ./src/components/types/InlineEditorForm.js